import { Label } from '@/components/ui/label';
import { Skeleton } from '@/components/ui/skeleton';

interface FilterSkeletonProps {
  label: string;
}

export function FilterSkeleton({ label }: FilterSkeletonProps) {
  return (
    <div className="flex flex-col gap-2">
      <Label>{label}</Label>
      <Skeleton className="h-10 w-64" />
    </div>
  );
}
